const copyWrapperCls = "_arac1yb3r1a";
const copyLabelCls = "_arac4dwro1";

export { copyLabelCls, copyWrapperCls };
import "./button.style.linaria.module.css";
//# sourceMappingURL=button.style.js.map
